(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/customer-service/assets/javascripts/views/common-questions.js') >= 0) return;  svs.modules.push('/modules/customer-service/assets/javascripts/views/common-questions.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.customer_service.views.CommonQuestions = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.customer_service.templates.common_questions(data);
    },
    tagName: 'div',
    id: 'commonQuestions',
    className: 'bg-white',
    modelEvents: {
      change: 'render'
    },
    ui: {
      searchResult: '.search-result',
      faqHeader: '.faq-header',
      faqIndex: '.index',
      searchCancel: '.search-back-btn',
      iconSearch: '.icon-search',
      btnClose: '.close-btn',
      btnReturn: '.return-btn',
      searchInput: '.js-input',
      faqGroup: '.faq-group',
      searchForm: '.js-search-form'
    },
    events: {
      'focusin @ui.searchInput': 'inputCleared',
      'submit @ui.searchForm': 'preventSubmit',
      'click @ui.btnClose, @ui.btnReturn': 'endSearch'
    },

    initialize: function() {
      this.hasQuicksearchInit = false;
      this.loader = new svs.components.Loader('.js-loader-container');
    },

    inputAnalytics: function(val) {
      var searchResultNo = this.$el.find('.faq-item.show').length,
        evt = {
          category: 'Kundservice',
          action: 'Search',
          opt_label: val,
          opt_value: searchResultNo
        };
      svs.components.analytics.trackEvent(evt);
    },

    inputCleared: function() {
      this.loader.show(200, 'inverted');
      var self = this;
      if (!this.hasQuicksearchInit) {
        this.hasQuicksearchInit = true;

        this.ui.searchInput.quicksearch('.faq-item', {
          delay: 500,
          selector: '.search-question, .search-answer',
          bind: 'keyup',
          loader: '.js-loader-container',
          onBefore: function() {
            self.ui.faqIndex
              .addClass('hide')
              .next()
              .attr('class', 'col-xs-12');
            self.ui.faqHeader.addClass('hide');
            self.ui.searchResult.removeClass('hide');
            self.ui.searchCancel.removeClass('hide').addClass('show');

            if (this.val().length < 3) {
              self.ui.faqGroup.addClass('hide');
              self.indexSearchResult('0');
              self.ui.btnClose.removeClass('hide').addClass('show');
            }
          },
          onAfter: function() {
            clearTimeout(self.searchTimeout);

            if (this.val().length > 2) {
              self.ui.faqGroup.removeClass('hide');
              self.indexSearchResult();
              self.ui.btnClose.removeClass('hide').addClass('show');
              self.searchTimeout = setTimeout(function() {
                self.inputAnalytics(self.ui.searchInput.val());
              }, 5000);
            }
          },
          show: function() {
            var item = $(this);
            self.ui.searchInput.keyup(function() {
              self.ui.faqGroup.addClass('hide');
              item.removeClass('hide').addClass('show');
            });
          },
          hide: function() {
            $(this)
              .removeClass('show')
              .addClass('hide');
          }
        });
      }
    },

    endSearch: function() {
      this.ui.searchInput.val('');
      this.ui.faqIndex
        .removeClass('hide')
        .next()
        .attr('class', 'col-xs-11');
      this.ui.searchResult.addClass('hide');
      this.ui.faqGroup.removeClass('hide');
      this.ui.searchCancel.removeClass('show').addClass('hide');
      this.ui.faqHeader.removeClass('hide');
      this.ui.btnClose.removeClass('show').addClass('hide');
      this.$el
        .find('.faq-item')
        .removeClass('hide show')
        .each(function(i) {
          i <= 4 ? $(this).addClass('show') : $(this).addClass('hide');
        });
      this.$el.parents('.js-swiper-container').animate(
        {
          scrollTop: 0
        },
        500
      );
    },

    indexSearchResult: function(val) {
      var $items = this.$el.find('.faq-item.show').length;
      !val ? this.ui.searchResult.find('span').html($items + ' ') : this.ui.searchResult.find('span').html(val + ' ');
    },

    preventSubmit: function(e) {
      e.preventDefault();
    }
  });
})(Backbone, _, svs);

 })(window);